// Shared services data for use across components
export const services = [
  {
    id: 'site-clearing',
    title: 'Site Clearing',
    slug: 'site-clearing',
    image: '/Construction_images/site_clearing.jpg',
    description: 'Complete site preparation including tree removal, brush clearing, and debris removal to prepare your site for construction.',
    details: [
      'Tree and vegetation removal',
      'Brush and debris clearing',
      'Site preparation and cleanup',
      'Environmental compliance',
      'Erosion control measures',
      'Stump grinding and removal'
    ],
    icon: '/icons/TB_Icons_Shavel.png',
    metaDescription: 'Professional site clearing services in the Greater Boston Area. Tree removal, brush clearing, and debris removal for residential and commercial construction projects.',
    metaKeywords: 'site clearing, tree removal, brush clearing, Boston construction, site preparation'
  },
  {
    id: 'excavation',
    title: 'Excavation',
    slug: 'excavation',
    image: '/Construction_images/excavation.jpg',
    description: 'Professional excavation services for foundations, utilities, and site preparation with precision and expertise.',
    details: [
      'Foundation excavation',
      'Utility trenching',
      'Site preparation',
      'Bulk earth moving',
      'Precision grading excavation',
      'Drainage system installation'
    ],
    icon: '/icons/TB_Icons_Truck 3.png',
    metaDescription: 'Expert excavation services in the Greater Boston Area. Foundation excavation, utility trenching, and site preparation for residential and commercial projects.',
    metaKeywords: 'excavation, foundation excavation, utility trenching, Boston excavation, earth moving'
  },
  {
    id: 'grading',
    title: 'Grading',
    slug: 'grading',
    image: '/Construction_images/site_grading.jpg',
    description: 'Expert grading services to ensure proper drainage, level surfaces, and compliance with building codes and regulations.',
    details: [
      'Site leveling and grading',
      'Drainage system design',
      'Slope stabilization',
      'Building code compliance',
      'Final grade preparation',
      'Erosion control implementation'
    ],
    icon: '/icons/TB_Icons_Measuring Tool.png',
    metaDescription: 'Professional site grading services in the Greater Boston Area. Site leveling, drainage design, and slope stabilization for construction projects.',
    metaKeywords: 'site grading, leveling, drainage design, Boston grading, slope stabilization'
  },
  {
    id: 'foundation',
    title: 'Foundation',
    slug: 'foundation',
    image: '/Construction_images/Foundation_forms.jpg',
    description: 'Complete foundation services including excavation, formwork, and preparation for your building foundation.',
    details: [
      'Foundation excavation',
      'Formwork installation',
      'Reinforcement placement',
      'Concrete pouring',
      'Foundation waterproofing',
      'Inspection coordination'
    ],
    icon: '/icons/TB_Icons_Hammer.png',
    metaDescription: 'Complete foundation services in the Greater Boston Area. Foundation excavation, formwork, and concrete pouring for residential and commercial buildings.',
    metaKeywords: 'foundation, foundation excavation, formwork, Boston foundation, concrete foundation'
  },
  {
    id: 'backfilling',
    title: 'Backfilling',
    slug: 'backfilling',
    image: '/Construction_images/excavation_wide.jpg',
    description: 'Professional backfilling services to properly fill and compact around foundations and utilities.',
    details: [
      'Foundation backfilling',
      'Utility trench backfilling',
      'Proper compaction',
      'Material selection',
      'Drainage considerations',
      'Final grade restoration'
    ],
    icon: '/icons/TB_Icons_Truck 2.png',
    metaDescription: 'Professional backfilling services in the Greater Boston Area. Foundation and utility trench backfilling with proper compaction and material selection.',
    metaKeywords: 'backfilling, foundation backfilling, utility backfilling, Boston backfilling, compaction'
  },
  {
    id: 'screening-processing',
    title: 'Screening & Processing',
    slug: 'screening-processing',
    image: '/Construction_images/screening_processing.jpg',
    description: 'On-site screening and processing of natural raw materials to meet your project specifications.',
    details: [
      'On-site material screening',
      'Gravel processing',
      'Rock crushing',
      'Material sorting',
      'Quality control',
      'Custom material specifications'
    ],
    icon: '/icons/TB_Icons_Truck 1.png',
    metaDescription: 'On-site screening and processing services in the Greater Boston Area. Gravel processing, rock crushing, and material sorting for construction projects.',
    metaKeywords: 'screening, material processing, gravel processing, rock crushing, Boston screening'
  },
  {
    id: 'landscaping',
    title: 'Landscaping',
    slug: 'landscaping',
    image: '/Construction_images/Landscaping.jpg',
    description: 'Complete landscaping services to transform your site with professional design and installation.',
    details: [
      'Landscape design',
      'Planting and installation',
      'Hardscape construction',
      'Lawn installation',
      'Mulching and soil preparation',
      'Maintenance planning'
    ],
    icon: '/icons/TB_Icons_Shavel.png',
    metaDescription: 'Complete landscaping services in the Greater Boston Area. Landscape design, planting, hardscape construction, and lawn installation for residential and commercial properties.',
    metaKeywords: 'landscaping, landscape design, hardscape, Boston landscaping, lawn installation'
  },
  {
    id: 'irrigation',
    title: 'Irrigation Services',
    slug: 'irrigation',
    image: '/Construction_images/Landscaping_UrbanIrrigation_TB.jpg',
    description: 'Comprehensive irrigation system design, installation, and maintenance for optimal water management.',
    details: [
      'Irrigation system design',
      'Sprinkler installation',
      'Drip irrigation systems',
      'Water-efficient solutions',
      'System maintenance',
      'Seasonal adjustments'
    ],
    icon: '/icons/TB_Icons_Measuring Tape.png',
    metaDescription: 'Professional irrigation services in the Greater Boston Area. Irrigation system design, sprinkler installation, and water-efficient solutions for residential and commercial properties.',
    metaKeywords: 'irrigation, sprinkler installation, drip irrigation, Boston irrigation, water-efficient irrigation'
  }
];

